import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "16",
  fill: "none",
  viewBox: "3913 393 20 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3925 402h5v-2h-5zm0-3h5v-2h-5zm-9 6h8v-.55q0-1.125-1.1-1.788-1.1-.662-2.9-.662t-2.9.662-1.1 1.788zm4-4q.825 0 1.412-.588.589-.587.588-1.412 0-.825-.588-1.412A1.93 1.93 0 0 0 3920 397q-.825 0-1.412.588A1.92 1.92 0 0 0 3918 399q0 .825.588 1.412.587.588 1.412.588m-5 8q-.825 0-1.412-.588A1.92 1.92 0 0 1 3913 407v-12q0-.825.588-1.412A1.93 1.93 0 0 1 3915 393h16q.825 0 1.412.588.589.587.588 1.412v12q0 .825-.588 1.412A1.93 1.93 0 0 1 3931 409zm0-2h16v-12h-16zm0 0v-12z",
      class: "fills",
      style: {"fill":"#1f7eff","fill-opacity":"1"}
    }, null, -1)
  ]))]))
}
export default { render: render }